import axios from 'axios'
import config from './config.js'
import { Base64 } from 'js-base64'
import auth from '../models/auth.js'
import user from '../models/user.js'
import router from '../router'
import store from '../store'
import { isMobile, isWeiXin } from '../utils/utils.js'
// create an axios instance
const service = axios.create({
  baseURL: config.profile, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000 // request timeout
})

// request interceptor
console.log('this.$store',store)
axios.interceptors.request.use(
  
  config => {
    let baseStr =store.state.user.application.clientId+':'+store.state.user.application.clientSecret;
    if (auth.gettoken()) {
      config.headers['cloud-auth'] = 'bearer ' + auth.gettoken()
      config.headers['Authorization'] =
        'Basic ' + Base64.encode(baseStr)
    } else {
      config.headers['Authorization'] =
        'Basic ' + Base64.encode(baseStr)//'cloud_app:cloud_app_secret'
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
axios.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res.code === 200) {
      return res
    } else {
      if (res.code === 401) {
        auth.clean()
        user.clean()
        if (isMobile() || isWeiXin()) {
          router.push({
            name: 'Waplogin',
            query: { r: router.history.current.fullPath }
          })
        } else {
          router.push({
            name: 'Login',
            query: { r: router.history.current.fullPath }
          })
        }
      }
      return Promise.reject({ code: res.code, message: res.msg })
    }
  },
  error => {
    const response = error.response
    const status = response.status
    if (status === 401) {
      auth.clean()
      user.clean()
      if (isMobile() || isWeiXin()) {
        router.push({
          name: 'Waplogin',
          query: { r: router.history.current.fullPath }
        })
      } else {
        router.push({
          name: 'Login',
          query: { r: router.history.current.fullPath }
        })
      }
      return Promise.reject({
        messsage: '登录已失效，请重新登录！',
        code: 401
      })
    }
    return Promise.reject({ code: 9001, message: '数据请求失败，请稍后重试~' })
  }
)

service.get = function(path, params) {
  return axios({
    method: 'get',
    url: `${config.profile.host}${path}`,
    params: params
  })
}

service.post = function(path, params) {
  return axios({
    method: 'post',
    url: `${config.profile.host}${path}`,
    params: params
  })
}

service.postdata = function(path, params) {
  return axios({
    method: 'post',
    url: `${config.profile.host}${path}`,
    data: params
  })
}

service.postDataWithHeader = function(path, params, header) {
  return axios({
    method: 'post',
    url: `${config.profile.host}${path}`,
    data: params,
    headers: header
  })
}

export default service
